import React from 'react';
import LazySection from '../@shared/lazySection';

const MockedComponentMessage = () => {
  return (
    <LazySection>
      <section className={'mocked-component-message'}>
        <p className={'mocked-component-message__title'}>The component does not have the datasource selected</p>
      </section>
    </LazySection>
  );
};

export default MockedComponentMessage;
